import React, { Fragment, useEffect, useState } from 'react'
import { connect } from 'react-redux'
import './TaskContainer.scss'
import { useIntl } from 'react-intl'
import { NEW_ACTIVITY_CREATION_REDUCER_NAMESPACE } from '@/app/redux/reducers/activity-creation'
import {
    removeTask,
    setSchedulingMaxEndDate,
    setSchedulingMinStartDate,
    setTaskStatus,
} from '@/app/redux/actions/activity-creation'
import ActionItemContainer from '../../../UI/ActionItemContainer/ActionItemContainer'
import ActionItemDone from '../ActionItemDone/ActionItemDone'
import Task from '../Task/Task'
import { Task as ITask } from '@/app/models/new-activity-creation-state'
import { getRemainingDays } from '@/app/utils/commonFunctions'
import moment from 'moment'

const TaskContainer = (props) => {
    const {
        taskList,
        questionList,
        setStatus,
        removeTask,
        isDisabled,
        onTaskSave,
        onTask,
        setSchedulingMinStartDate,
        schedulingMinStartDate,
        setSchedulingMaxEndDate,
        schedulingMaxEndDate,
    } = props
    const intl = useIntl()
    const [showAddLink, setShowAddLink] = useState(false)

    const onAddTask = () => {
        setStatus(taskList.length, {
            title: '',
            description: '',
            urgent: false,
            attachmentList: [],
            questionList: [],
            startDate: null,
            endDate: null,
            recipient: null,
        })
        setShowAddLink(true)
        onTask()
    }

    const onSave = (index: number, task: Partial<ITask>) => {
        setSchedulingMinStartDate(null)
        setSchedulingMaxEndDate(null)
        setShowAddLink(false)
        setStatus(index, task)
        onTaskSave()
    }

    useEffect(() => {
        // find new min and new max
        if (!schedulingMinStartDate) {
            let newStartDate
            taskList.forEach((task) => {
                newStartDate =
                    (!newStartDate && !!task.startDate) ||
                    (!!task.startDate &&
                        getRemainingDays(moment(newStartDate), moment(task.startDate)) < 0)
                        ? task.startDate
                        : newStartDate
            })
            setSchedulingMinStartDate(newStartDate)
        }
    }, [taskList, schedulingMinStartDate])

    useEffect(() => {
        // find new min and new max
        if (!schedulingMaxEndDate) {
            let newEndDate
            taskList.forEach((task) => {
                newEndDate =
                    (!newEndDate && !!task.endDate) ||
                    (!!task.endDate &&
                        getRemainingDays(moment(newEndDate), moment(task.endDate)) > 0)
                        ? task.endDate
                        : newEndDate
            })
            setSchedulingMaxEndDate(newEndDate)
        }
    }, [taskList, schedulingMaxEndDate])

    const onTaskEdit = (index: number) => {
        setStatus(index, { isEdit: true })
        setShowAddLink(true)
    }
    const onRemove = (index: number) => {
        removeTask(index)
    }
    const onReduce = (index: number, task: Partial<ITask>) => {
        setShowAddLink(false)
        if (task.isEdit) {
            setStatus(index, { isEdit: false })
            return
        }
        onRemove(index)
    }

    return (
        <ActionItemContainer
            hasItems={taskList.length > 0}
            hasBorderTop={questionList.length === 0 && taskList.length > 0}
            showAddLink={showAddLink || isDisabled}
            onAddItem={() => onAddTask()}
            title={intl.formatMessage({
                id: 'modals.new.activity.section.action.item.title.task',
                defaultMessage: 'Add task',
            })}>
            {taskList.map((task, index) => (
                <Fragment key={index}>
                    {task.isDone && !task.isEdit && (
                        <ActionItemDone
                            title={intl.formatMessage(
                                {
                                    id: 'modals.new.activity.section.action.task.done',
                                    defaultMessage: 'Saved task is here',
                                },
                                { index: index + 1 }
                            )}
                            onEdit={() => onTaskEdit(index)}
                            onRemove={() => onRemove(index)}
                        />
                    )}
                    {(!task.isDone || task.isEdit) && (
                        <Task
                            title={intl.formatMessage(
                                {
                                    id: 'modals.new.activity.section.action.task.title',
                                    defaultMessage: 'Task',
                                },
                                { index: index + 1 }
                            )}
                            form={task}
                            taskIndex={index}
                            onSave={(task) => onSave(index, task)}
                            onReduce={() => onReduce(index, task)}
                            disabled={isDisabled}
                        />
                    )}
                </Fragment>
            ))}
        </ActionItemContainer>
    )
}

const mapStateToProps = (state: any) => ({
    taskList: state[NEW_ACTIVITY_CREATION_REDUCER_NAMESPACE].taskList,
    questionList: state[NEW_ACTIVITY_CREATION_REDUCER_NAMESPACE].questionList,
    schedulingMinStartDate: state[NEW_ACTIVITY_CREATION_REDUCER_NAMESPACE].schedulingMinStartDate,
    schedulingMaxEndDate: state[NEW_ACTIVITY_CREATION_REDUCER_NAMESPACE].schedulingMaxEndDate,
})

const mapDispatchToProps = (dispatch: any) => ({
    setStatus: (index: number, task: Partial<ITask>) => dispatch(setTaskStatus(index, task)),
    removeTask: (index: number) => dispatch(removeTask(index)),
    setSchedulingMinStartDate: (value: number) => dispatch(setSchedulingMinStartDate(value)),
    setSchedulingMaxEndDate: (value: number) => dispatch(setSchedulingMaxEndDate(value)),
})

export default connect(mapStateToProps, mapDispatchToProps)(TaskContainer)
